import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Testimonial } from 'src/libs-common/models/testimonial.model';
import { Subject, Subscription, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'testimonial-fader',
  templateUrl: './testimonial-fader.component.html',
  styleUrls: ['./testimonial-fader.component.scss'],
})
export class TestimonialFaderComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('testimonialCard') testimonialCard: ElementRef | undefined;
  @ViewChild('testimonialData') testimonialData: ElementRef | undefined;
  @Input() testimonials: Testimonial[] | null = [];

  private destroy$: Subject<void> = new Subject<void>();
  private intervalSubscription?: Subscription; // Reference to the interval subscription

  indicators = true;
  controls = true;
  autoFade = false;
  slideInterval = 5000;
  reviewHeight?: number | null = 500;
  cardHeight?: any | null = null;
  selectedIndex = 0;
  changing = false;

  constructor() {}

  ngOnInit(): void {
    if (this.autoFade) {
      this.startTestimonials();
    }
  }

  ngAfterViewInit(): void {
    this.calculateCardHeight();
    // Start the slideshow automatically when autoFade is true
    if (this.autoFade) {
      this.startTestimonials();
    }
  }

  selectTestimonial(index: number) {
    this.changing = true;
    setTimeout(() => {
      this.selectedIndex = index;
    }, 400);
    setTimeout(() => {
      this.changing = false;
    }, 900);
  }

  calculateCardHeight() {
    this.cardHeight = this.testimonialCard?.nativeElement.offsetHeight;
  }

  calculateReviewHeight() {
    this.reviewHeight = this.testimonialData?.nativeElement.offsetHeight;
  }

  onPrevClick() {
    this.selectTestimonial(
      this.selectedIndex === 0
        ? this.testimonials!.length - 1
        : this.selectedIndex - 1
    );
    this.resetTimer();
  }

  onNextClick() {
    this.selectTestimonial(
      (this.selectedIndex + 1) % this.testimonials!.length
    );
    this.resetTimer();
  }

  startTestimonials() {
    this.pauseTestimonials(); // Clear any existing interval.

    this.intervalSubscription = interval(this.slideInterval)
      .pipe(takeUntil(this.destroy$)) // Clean up the subscription when the component is destroyed.
      .subscribe(() => {
        this.onNextClick();
      });
  }

  pauseTestimonials() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe(); // Unsubscribe from the interval observable.
    }
  }

  resetTimer() {
    this.pauseTestimonials();
    this.startTestimonials();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
